// @flow

import { observer } from "mobx-react";
import React from "react";

import Video from "app/models/Video";
import VideoCards from "app/components/VideoCards/VideoCards";

import "./RelatedTimelines.scss";

type Props = {
    videos: Video[],
    serverTime: any,
    theme: string
};

@observer
export default class RelatedTimelines extends React.Component<Props> {
    render() {
        if (this.props.videos.length === 0) {
            return null;
        }

        return (
            <div className="RelatedTimelines">
                <h3 className="RelatedTimelines__title">Related content</h3>

                <ul className="RelatedTimelines__items">
                    <VideoCards
                        videos={this.props.videos}
                        serverTime={this.props.serverTime}
                        theme={this.props.theme}
                        breakpointClasses="col-xs-12"
                        onlyTimeline={true}
                    />
                </ul>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/RelatedTimelines/RelatedTimelines.js